import {resendUserManagementInvitation} from "@project/sdk/user-management";
import {
  ResendUserManagementInvitationHeader,
  ResendUserManagementInvitationResponse,
} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function resendUserManagementInvitationMutationOptions() {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.resendUserManagementInvitation,
    mutationFn: async ({userId, idempotencyKey}: {userId: string; idempotencyKey: string}) =>
      ResendUserManagementInvitationResponse.parse(
        await resendUserManagementInvitation(userId, {
          headers: ResendUserManagementInvitationHeader.parse({"Idempotency-Key": idempotencyKey}),
        }),
      ),
    onSuccess: async (_data, {userId}, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: userManagementUserKeys.detail(userId)}),
        client.invalidateQueries({queryKey: userManagementUserKeys.lists()}),
      ]);
    },
  });
}
